module.exports = __webpack_public_path__ + "static/ali-63f0fe0333a8216ec532c0f38129e45d.png";